module.exports = __webpack_public_path__ + "img/fo.35e97fc3.svg";